import { Alert, Modal } from 'react-bootstrap'
import CarnivoreModalProps from '../../_types/modal-props.type'
import { useDispatch, useSelector } from 'react-redux'
import { CarnivoreState } from '../../_types/carnivore-state.type'
import { FormEvent, useEffect, useState } from 'react'
import {
    Box,
    Button,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography
} from '@mui/material'
import { StyleHelper } from '../../helpers/styler-helper'
import RichTextEditor from '../rich-text-editor'
import Grid2 from '@mui/material/Unstable_Grid2'
import { Academy } from '../../_types/academy.type'
import { Formatters } from '../../helpers/formatters'
import { AcademyService } from '../../services/academy.service'
import Actions from '../../redux/actions'

interface AcademyModalProps extends CarnivoreModalProps {
    initialAcademy: Academy | null
}

export default function AcademyModal(props: AcademyModalProps) {
    const error = useSelector((state: CarnivoreState) => state.errMsg)
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState('')
    const [capacity, setCapacity] = useState('')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const dispatch = useDispatch()
    const academyService = new AcademyService(dispatch)
    const [description, setDescription] = useState('')
    const [formData, setFormData] = useState<any>({
        name: '',
        description: '',
        capacity: '',
        price: '',
        startDate: '',
        endDate: '',
        ...props.initialAcademy
    })
    const _onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        setLoading(true)

        if (props.initialAcademy) {
            //tada
        }

        const data = JSON.parse(JSON.stringify(formData))

        data.price = Math.round(Number(data.price) * 100)
        data.capacity = Number(data.capacity)
        const res = await academyService.createAcademy(
            data,
            Intl.DateTimeFormat().resolvedOptions().timeZone
        )
        dispatch(
            Actions.setToast('Academy Created', 'This academy is live')
        )
        props.onClose()

    }

    useEffect(() => {
        if (props.initialAcademy) {
            const acad = props.initialAcademy

            setFormData({
                name: acad.name,
                description: acad.description,
                capacity: `${acad.capacity}`,
                price: `${(acad.price / 100).toFixed(2)}`,
                startDate: Formatters.isoStringToLocalTimeInput(acad.startDate),
                endDate: Formatters.isoStringToLocalTimeInput(acad.endDate),
            })


        } else {
            setFormData({
                name: '',
                capacity: '',
                price: '',
                description: '',
                startDate: '',
                endDate: '',
            })
        }
    }, [props.initialAcademy])

    const handleChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        const { name, value, type, checked } = e.target as any
        console.log(value)

        setFormData((prev: any) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }))
    }

    return (
        <Modal show={props.show} onHide={props.onClose} centered size='xl'>
            <Modal.Header closeButton>
                <Modal.Title>Create Academy</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {error && <Alert variant='danger my-3'>{error}</Alert>}

                <form onSubmit={_onSubmit}>

                    <TextField
                        name='name'
                        label='Name'
                        placeholder='public facing name'
                        required
                        variant='outlined'
                        fullWidth
                        value={formData.name}
                        onChange={handleChange}
                    />
                    <StyleHelper.VerticalSpace />
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <TextField
                                name='price'
                                label='Price'
                                placeholder='00.00'
                                required
                                variant='outlined'
                                type='number'
                                fullWidth
                                value={formData.price}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                label='Max Capacity'
                                placeholder='ex 30'
                                required
                                variant='outlined'
                                fullWidth
                                type='number'
                                value={formData.capacity}
                                name="capacity"
                                onChange={handleChange}

                            />
                        </Grid>
                    </Grid>


                    <StyleHelper.VerticalSpace />


                    <TextField
                        label='Description'
                        placeholder='public facing short description'
                        required
                        variant='outlined'
                        fullWidth
                        multiline={true}
                        rows={8}
                        value={formData.description}
                        name="description"
                        onChange={handleChange}
                    />
                    <StyleHelper.VerticalSpace />

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography fontWeight={'bold'}>Start Time</Typography>
                            <TextField
                                type='datetime-local'
                                placeholder='public facing short description'
                                required
                                variant='outlined'
                                fullWidth
                                value={formData.startDate}
                                name="startDate"
                                onChange={handleChange}
                            />



                        </Grid>
                        <Grid item xs={6}>
                            <Typography fontWeight={'bold'}>End Time</Typography>

                            <TextField
                                type='datetime-local'
                                placeholder='public facing short description'
                                required
                                variant='outlined'
                                fullWidth
                                value={formData.endDate}
                                name='endDate'
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>

                    <Divider />
                    <StyleHelper.VerticalSpace />


                    <Button disabled={loading} variant='contained' type='submit'>Create Academy</Button>
                </form>
            </Modal.Body>
        </Modal>
    )
}
